module.exports = __webpack_public_path__ + "static/media/sharechat.43c0f8ea.webp";